import { cn } from "../../lib/utils";

const MetricCard = (props) => {
  const {
    title,
    value,
    change,
    icon: Icon,
    className,
    delay = 0,
  } = props;

  const isPositive = change !== undefined && change > 0;
  const isNegative = change !== undefined && change < 0;

  return (
    <div
      className={cn(
        "glass-card p-6 animate-slide-up glow-effect",
        className
      )}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground font-medium">
            {title}
          </p>

          <p className="metric-value text-foreground">
            {value}
          </p>

          {change !== undefined && (
            <div className="flex items-center gap-1">
              <span
                className={cn(
                  "text-sm font-medium",
                  isPositive && "text-success",
                  isNegative && "text-destructive",
                  !isPositive && !isNegative && "text-muted-foreground"
                )}
              >
                {isPositive && "+"}
                {change}%
              </span>
              <span className="text-xs text-muted-foreground">
                vs last period
              </span>
            </div>
          )}
        </div>

        <div className="p-3 rounded-lg bg-primary/10">
          <Icon className="h-5 w-5 text-primary" />
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
